// skipcq: JS-W1028
import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import {
  CardContent,
  CardActions,
  Button,
  Typography,
  CircularProgress,
  Box,
} from '@mui/material';
import DashboardSurfaceCard from './DashboardSurfaceCard';
import { BEER_DUPLICATE_REVIEWS_COLLECTION } from '../../utils/firestoreCollections';
import { getCollectionCount } from '../../utils/firestoreCounts';

function BeerDuplicateReviewsCard() {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;

    async function loadCount() {
      setLoading(true);
      setError(null);
      try {
        const pendingCount = await getCollectionCount(
          BEER_DUPLICATE_REVIEWS_COLLECTION,
          'status',
          'pending',
        );
        if (!cancelled) {
          setCount(Number(pendingCount) || 0);
        }
      } catch (loadError) {
        if (!cancelled) {
          setError(loadError?.message || 'Error loading data');
          setCount(0);
        }
      } finally {
        if (!cancelled) {
          setLoading(false);
        }
      }
    }

    loadCount();
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <DashboardSurfaceCard data-testid="beer-duplicate-reviews-card">
      <CardContent sx={{ flexGrow: 1 }}>
        <Typography variant="h6" component="h2" gutterBottom>
          Beer Duplicate Reviews
        </Typography>
        <Typography variant="body2" paragraph sx={{ color: 'text.secondary' }}>
          Review potential duplicate beers flagged during import
        </Typography>

        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', py: 2 }}>
            <CircularProgress size={24} />
          </Box>
        ) : error ? (
          <Typography variant="body2" color="error">
            Error loading data
          </Typography>
        ) : (
          <>
            <Typography variant="h4" component="div" sx={{ color: 'warning.main' }}>
              {count.toLocaleString()}
            </Typography>
            <Typography variant="body2" sx={{ color: 'text.secondary' }}>
              Pending reviews
            </Typography>
          </>
        )}
      </CardContent>
      <CardActions>
        <Button
          variant="outlined"
          component={Link}
          to="/beer?tab=dupes"
          fullWidth
        >
          Review duplicates
        </Button>
      </CardActions>
    </DashboardSurfaceCard>
  );
}

export default BeerDuplicateReviewsCard;
